import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { resolveShopTheme, themeCssVars } from '../theme';
import { useI18n } from '../i18n';
import { AccentButton, QuietButton, SmallCaps } from '../components/ShopChrome';

const CancelPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const theme = resolveShopTheme(null);

  return (
    <div className="flex min-h-screen items-center justify-center px-5" style={themeCssVars(theme)}>
      <div className="w-full max-w-[440px]">
        <SmallCaps theme={theme}>{t('cancel.eyebrow')}</SmallCaps>
        <h1
          style={{
            margin: '12px 0 8px',
            font: `500 clamp(26px, 5vw, 32px)/1.15 ${theme.fontFamily}`,
            letterSpacing: '-.02em',
            color: theme.ink,
          }}
        >
          {t('cancel.title')}
        </h1>
        <p style={{ margin: '0 0 28px', font: `400 15px/1.6 ${theme.fontFamily}`, color: theme.muted }}>
          {t('cancel.body')}
        </p>
        <div className="flex flex-col gap-2.5 sm:flex-row">
          <AccentButton theme={theme} onClick={() => navigate('/checkout')} className="flex-1">
            {t('common.try_again')}
          </AccentButton>
          <QuietButton theme={theme} onClick={() => navigate(-1)} className="flex-1">
            <ArrowLeft className="h-4 w-4" />
            {t('cancel.go_back')}
          </QuietButton>
        </div>
      </div>
    </div>
  );
};

export default CancelPage;
